import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { css } from "styled-components";

orderUploadStyles.mainWrapper = {
    css: css`
        width: 100%;
        div[class^="UploadWrapper-sc"] {
            div[class^="ButtonWrapper-sc"] {
                label {
                    margin: 27px 0 0 15px;
                }
            }
        }
    `,
};
